export function copyText({
  textToCopy,
}: {
  textToCopy: string;
  notificationMessage?: string;
}) {
  navigator.clipboard.writeText(textToCopy);
}
